{
  "tabs": {
    "dashboard": "Dashboard",
    "dungeons": "Dungeons",
    "validation": "Validation",
    "heroes": "Heroes",
    "bestiary": "Bestiary",
    "weapons": "Weapons",
    "tuning": "Tuning",
    "live": "Live",
    "game-settings": "Game settings",
    "settings": "Settings"
  },
  "pack": {
    "label": "Pack",
    "loading": "Loading the packs…"
  },
  "status": {
    "label": "Status",
    "sim": "Sim",
    "live": "Live link",
    "pass": "Workshop pass",
    "passOk": "ready",
    "passFailed": "refused",
    "simReady": "{{count}} biomes",
    "sim_loading": "loading…",
    "sim_missing": "no biome catalog for this pack",
    "sim_error": "failed (hover for why)",
    "liveOn": "{{game}} ({{pack}}) on port {{port}}",
    "live_idle": "not connected",
    "live_connecting": "connecting…",
    "live_error": "refused: connect again"
  },
  "coming": {
    "title": "Coming",
    "lead": "The {{tab}} tab is being ported from the desktop Workshop. Until then, use the desktop app for it."
  },
  "dashboard": {
    "title": "Dashboard",
    "lead": "The pack at a glance.",
    "heroes": "Heroes",
    "monsters": "Monsters",
    "weapons": "Weapons",
    "soundsMissing": "Sounds missing",
    "sheet": "Hero Sheet",
    "noWeapons": "none",
    "open": "Open",
    "validate": "Validate every biome ({{seeds}} seeds × {{depths}} floors)",
    "cancel": "Cancel ({{done}}/{{total}})",
    "export": "Download the to-do list",
    "onlyTodo": "Only what needs work",
    "allOk": "Everything here is complete.",
    "nothing": "Nothing here."
  }
}
